import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { formatCurrency } from '../../utils/currency';

const MyLease = () => {
    const [l, setL] = useState(null);
    useEffect(() => { axios.get('/api/portal/lease').then(r => setL(r.data.lease)).catch(() => {}); }, []);
    if (!l) return <div>Loading…</div>;
    return (
        <div className="max-w-3xl mx-auto space-y-4">
            <h1 className="text-2xl font-bold">My lease</h1>
            <div className="bg-white rounded-xl border p-6 grid grid-cols-2 gap-4 text-sm">
                <Field label="Property" value={l.property_name} />
                <Field label="Address" value={`${l.address}, ${l.city} ${l.zip_code}`} />
                <Field label="Lease start" value={new Date(l.lease_start_date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })} />
                <Field label="Lease end" value={l.lease_end_date ? new Date(l.lease_end_date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : 'Ongoing'} />
                <Field label="Monthly rent" value={formatCurrency(l.monthly_rent)} />
                <Field label="Deposit paid" value={formatCurrency(l.deposit_paid)} />
                <Field label="Status" value={l.status} />
            </div>
        </div>
    );
};
const Field = ({ label, value }) => <div><div className="text-gray-500 text-xs">{label}</div><div className="font-medium">{value}</div></div>;
export default MyLease;
